<template lang="pug">

  a-entity.gyroview

    .intro(ref="intro")

    .container(ref="container")


    //((progress+0.001)%0.2/0.2)*bgHeight
    //a-entity(:position="`0 ${progress>0? progress*bgHeight*5 : progress*bgHeight} 0`" )
      //a-plane(:position="`0 ${0.1902*bgHeight} 0`" :geometry="`width: ${bgWidth}; height: ${0.6196*bgHeight};`" :tex="`src: #scene1l6;`")
      a-plane(:position="`${s1[5].x*bgWidth*dis/(dis+d1)} ${s1[5].y*bgHeight*dis/(dis+d1)} ${d1}`" :geometry="`width: ${s1[5].w*bgWidth*dis/(dis+d1)}; height: ${s1[5].h*bgHeight*dis/(dis+d1)};`" :tex="`src: #scene1l5;`")
      a-plane(:position="`${s1[4].x*bgWidth*dis/(dis+d2)} ${s1[4].y*bgHeight*dis/(dis+d2)} ${d2}`" :geometry="`width: ${s1[4].w*bgWidth*dis/(dis+d2)}; height: ${s1[4].h*bgHeight*dis/(dis+d2)};`" :tex="`src: #scene1l4;`")
      a-plane(:position="`${s1[3].x*bgWidth*dis/(dis+d3)} ${s1[3].y*bgHeight*dis/(dis+d3)} ${d3}`" :geometry="`width: ${s1[3].w*bgWidth*dis/(dis+d3)}; height: ${s1[3].h*bgHeight*dis/(dis+d3)};`" :tex="`src: #scene1l3;`")
      a-plane(:position="`${s1[2].x*bgWidth*dis/(dis+d4)} ${s1[2].y*bgHeight*dis/(dis+d4)} ${d4}`" :geometry="`width: ${s1[2].w*bgWidth*dis/(dis+d4)}; height: ${s1[2].h*bgHeight*dis/(dis+d4)};`" :tex="`src: #scene1l2;`")
      a-plane(:position="`${s1[1].x*bgWidth*dis/(dis+d5)} ${s1[1].y*bgHeight*dis/(dis+d5)} ${d5}`" :geometry="`width: ${s1[1].w*bgWidth*dis/(dis+d5)}; height: ${s1[1].h*bgHeight*dis/(dis+d5)};`" :tex="`src: #scene1l1;`")
      a-plane(:position="`${s1[0].x*bgWidth*dis/(dis+d6)} ${s1[0].y*bgHeight*dis/(dis+d6)} ${d6}`" :geometry="`width: ${s1[0].w*bgWidth*dis/(dis+d6)}; height: ${s1[0].h*bgHeight*dis/(dis+d6)};`" :tex="`src: #scene1l0;`")
    a-plane(
      id="spinePlayer"
      v-if="sceneEntered && mode === MODES.KIDS"
      :position="`0 ${progress-0.2*currSceneIdx>0? -bgHeight*currSceneIdx + progress*bgHeight*5 : -bgHeight*0.2*currSceneIdx + progress*bgHeight} 0`"
      :geometry="`width: ${bgWidth}; height: ${bgHeight};`"
      :width="bgWidth"
      :height="bgHeight"
      :spine="`fade: ${monsterFade * Math.abs(progress%0.2/0.2-0.5)/0.5 }; bg: #scene1; texture: #scene1tex; atlas: #scene1atlas; json: #scene1json; animation: animation; texture2: #scene2tex; atlas2: #scene2atlas; json2: #scene2json; texture3: #scene3tex; atlas3: #scene3atlas; json3: #scene3json; texture4: #scene4tex; atlas4: #scene4atlas; json4: #scene4json; texture5: #scene5tex; atlas5: #scene5atlas; json5: #scene5json; currIdx: ${currSceneIdx+1};`"
    )

    a-plane(
      :position="`0 ${-bgHeight + progress*bgHeight} 0`"
      :geometry="`width: ${bgWidth}; height: ${bgHeight};`"
      :width="bgWidth"
      :height="bgHeight"
      :scenes="scene2"
    )
    a-plane(
      :position="`0 ${progress-0.8>0? -4*bgHeight + progress*bgHeight*5 : -bgHeight*0.8 + progress*bgHeight} 0`"
      :geometry="`width: ${bgWidth}; height: ${bgHeight};`"
      :width="bgWidth"
      :height="bgHeight"
      :scenes="scene5"
    )
    a-plane(
      :position="`0 ${progress-0.6>0? -3*bgHeight + progress*bgHeight*5 : -bgHeight*0.6 + progress*bgHeight} 0`"
      :geometry="`width: ${bgWidth}; height: ${bgHeight};`"
      :width="bgWidth"
      :height="bgHeight"
      :scenes="scene4"
    )
    a-plane(
      :position="`0 ${progress-0.4>0? -2*bgHeight + progress*bgHeight*5 : -bgHeight*0.4 + progress*bgHeight} 0`"
      :geometry="`width: ${bgWidth}; height: ${bgHeight};`"
      :width="bgWidth"
      :height="bgHeight"
      :scenes="scene3"
    )
    a-plane(
      :position="`0 ${progress-0.2>0? -bgHeight + progress*bgHeight*5 : -bgHeight*0.2 + progress*bgHeight} 0`"
      :geometry="`width: ${bgWidth}; height: ${bgHeight};`"
      :width="bgWidth"
      :height="bgHeight"
      :scenes="scene2"
    )
    a-plane(
      :position="`0 ${progress>0? progress*bgHeight*5 : progress*bgHeight} 0`"
      :geometry="`width: ${bgWidth}; height: ${bgHeight};`"
      :width="bgWidth"
      :height="bgHeight"
      :scenes="scene1"
    )




    .loading


</template>

<script>


  import { mapState, mapMutations } from 'vuex'
  import Subtitles from 'src/components/vca/widgets/Subtitles'
  import * as MODES from 'src/config/modes'
  import ResizeService from 'src/services/ResizeService'
  import SoundService from 'src/services/SoundService'
  import * as PATHS from 'src/router/paths'


  import { TimelineMax } from 'gsap'
  import Raf from 'src/helpers/Raf'

  export default {
    name: 'GyroView',
    components: {
      Subtitles

    },
    data() {
      return {
        showLoop: false,
        moveable: false,
        // prettier-ignore
        // stories: [
        //   'products',
        // ],
        gtags: [
          'yosemite',
          'redwoods',
          'santabarbara',
          'montereybay',
          'lajolla'
        ],
        loading: {
          id: null,
          progress: 0,
        },
        p2:0,
        p3:0,
        p4:0,
        p5:0,
        progress: 0,
        currIdx: 0,
        MODES,
        copyFade: 1,
        copyProgress: 0,
        tweek:{
          rayDecay: 0.88,
          rayDensity: 0.6,
          rayWeight: 0.1
        },
        stories: [
          {
            played: false
          },
          {
            played: false
          },
          {
            played: false
          },
          {
            played: false
          },
          {
            played: false
          }
        ],
        t:{
          t1: 0,
          t2: -1,
          t3: -1,
          t4: -1,
          t5: -1,
        },
        p:{
          p1: 0,
          p2: 1,
          p3: 1,
          p4: 1,
          p5: 1,
        },

        dtEl:[],
        lastIdx: 0,
        offsetX: 0,
        offsetY: 0,
        monsterFade: 0,
        spineIdx: 0,

        dis: 413,
        d: [10, 20, 25, 30, 34, 38],
        s1: [
          {w: 0.7963, h: 0.6741, x: -0.1917, y: -0.2529},
          {w: 0.7351, h: 0.4316, x: 0.1978, y: -0.3235},
          {w: 0.5833, h: 0.5550, x: -0.0399, y: -0.2362},
          {w: 1.0761, h: 0.6139, x: -0.0018, y: -0.2384},
          {w: 0.9601, h: 0.3686, x: 0.0726, y: -0.2075},
          {w: 0.8982, h: 0.1848, x: 0.0978, y: -0.1027}
        ]
      }
    },
    props: {
      id: {
        //required: true,
        default: 1
      }
    },
    computed: {
      // d1(){
      //   if (this.mode === MODES.ADULTS)
      //     return this.d[0]
      //   else
      //     return 0
      // },
      // d2(){
      //   if (this.mode === MODES.ADULTS)
      //     return this.d[1]
      //   else
      //     return 0
      // },
      // d3(){
      //   if (this.mode === MODES.ADULTS)
      //     return this.d[2]
      //   else
      //     return 0
      // },
      // d4(){
      //   if (this.mode === MODES.ADULTS)
      //     return this.d[3]
      //   else
      //     return 0
      // },
      // d5(){
      //   if (this.mode === MODES.ADULTS)
      //     return this.d[4]
      //   else
      //     return 0
      // },
      // d6(){
      //   if (this.mode === MODES.ADULTS)
      //     return this.d[5]
      //   else
      //     return 0
      // },
      bgHeight() {

        let designRatio = 812/375
        let currRatio = this.windowHeight/this.windowWidth
        let ratio = designRatio/currRatio
        if (ratio === 1)
          return (this.windowHeight+100)
        return this.windowHeight*ratio
      },
      bgWidth() {

        let ratio = 1535 / 1024


        return this.bgHeight * ratio
      },

      ...mapState('app', ['seenIntro', 'sceneProgress', 'mode', 'showDestInfo', 'showSubtitles', 'muted', 'sceneEntered', 'currSceneIdx', 'showGallery', 'showMenu', 'modeSwitching']),
      ...mapState('browser', ['windowWidth', 'windowHeight', 'isAndroid', 'isIphoneX']),


      //r1dy: 2.4
      scene1(){
        if (this.sceneEntered)
          return `bg: #scene2; play: true; sceneEntered: true; shaderFx: dephyRay; depthMap: #scene2d;progress: 1; mode: ${this.mode}; rayDecay: ${this.tweek.rayDecay}; rayDensity: ${this.tweek.rayDensity}; rayWeight: ${this.tweek.rayWeight};`
        else
          return `fxOn: ${this.isIphoneX}; bg: #scene2; sceneEntered: false; mode: ${this.mode}; shaderFx: ray; r1x: 0.64; r1y: 1.05; r1dx: 1; r1dy: -9; r2x: 0.64; r2y: 1.05; r2dx: 1; r2dy: -9; rrs: 0.6; rgs: 0.6; rbs: 0.6; ds: 0.008; de: 1.01;`
      },
      scene2(){
        if (this.sceneEntered)
          return `bg: #scene1; play: true; sceneEntered: true; shaderFx: dephyRay; depthMap: #scene1d; progress: 1; mode: ${this.mode};`
        else
          return `fxOn: ${this.isIphoneX}; bg: #scene1; sceneEntered: false; mode: ${this.mode}; shaderFx: ray; r1x: 0.7; r1y: 1.4; r1dx: 1; r1dy: -0.116; r2x: 0.8; r2y: 1.6; r2dx: 1; r2dy: 0.241; rrs: 0; rgs: 0; rbs: 0; ds: 0.008; de: 1.01;`
      },
      scene3(){
        if (this.sceneEntered)
          return `bg: #scene3; play: true; sceneEntered: true; shaderFx: dephyRay; depthMap: #scene3d; progress: 1; mode: ${this.mode};`
        else
          return `fxOn: ${this.isIphoneX}; bg: #scene3; sceneEntered: false; mode: ${this.mode}; shaderFx: ray; r1x: 0.7; r1y: 1.4; r1dx: 1; r1dy: -0.116; r2x: 0.8; r2y: 1.6; r2dx: 1; r2dy: 0.241; rrs: 0; rgs: 0; rbs: 0; ds: 0.001; de: 1.01;`
      },
      scene4(){
        if (this.sceneEntered)
          return `bg: #scene4; play: true; sceneEntered: true; shaderFx: dephyRay; depthMap: #scene4d; progress: 1; mode: ${this.mode};`
        else
          return `fxOn: ${this.isIphoneX}; bg: #scene4; sceneEntered: false; mode: ${this.mode}; shaderFx: ray; r1x: 0.7; r1y: 1.4; r1dx: 1; r1dy: -0.116; r2x: 0.8; r2y: 1.6; r2dx: 1; r2dy: 0.241; rrs: 2; rgs: 1; rbs: 0.3; ds: 0.008; de: 1.01;`
      },
      scene5(){
        if (this.sceneEntered)
          return `bg: #scene5; play: true; sceneEntered: true; shaderFx: dephyRay; depthMap: #scene5d; progress: 1; mode: ${this.mode};`
        else
          return `fxOn: ${this.isIphoneX}; bg: #scene5; sceneEntered: false;  mode: ${this.mode}; shaderFx: ray; r1x: 0.7; r1y: 1.4; r1dx: 1; r1dy: -0.116; r2x: 0.8; r2y: 1.6; r2dx: 1; r2dy: 0.241; rrs: 1; rgs: 1.5; rbs: 1.5; ds: 0.005; de: 1;`
      },

    },
    beforeMount() {
      this.progress = (this.id-1)/4.0
      this.currIdx = this.id

      ResizeService.on(ResizeService.Events.RESIZE, this.updateLimit)
    },

    mounted() {
      window.GyroView = this

      this.camera = document.querySelector('.camera')




      Raf.add(this.updateProgress)


    },
    beforeDestroy() {
      //clearTimeout(this.timer)
      Raf.remove(this.updateProgress)
    },
    methods: {

      ...mapMutations('app', ['setCamZoom', 'setCamDistort', 'setSceneProgress', 'unlockMode']),
      animeIn(){

      },
      animeOut(){

      },
      updateLimit() {

        //camera.components['gyro-position'].limitX = this.bgWidth / 2 - this.windowWidth / 2

        if (this.sceneEntered){
          this.camera.components['gyro-position'].limitX = this.bgWidth / 2 - this.windowWidth / 2
          this.camera.components['gyro-position'].limitY = this.bgHeight / 2 - this.windowHeight / 2
          //this.camera.components['gyro-position'].multiplier = 0.5
        } else{
          this.camera.components['gyro-position'].limitX = 0
          this.camera.components['gyro-position'].limitY = 0
          //this.camera.components['gyro-position'].multiplier = 0.8
        }


      },

      // ***************************************************************************
      //
      // LOADING THE STORY
      //
      // ***************************************************************************
      end(){


        this.$router.replace({
          name: PATHS.ENDING,
        })

      },
      stopRolling(){
        Raf.remove(this.updateProgress)
      },
      resumeRolling(){
        Raf.add(this.updateProgress)
      },
      endRollback(){

        this.camera.components['gyro-position'].disableListener()
        Raf.remove(this.updateProgress)
        this.setSceneProgress(0)
        let tl = new TimelineMax({ onComplete: () => {
            Raf.add(this.updateProgress)
            window.App.camGyroOff()
          }
        })
        this.tl = tl
        tl.add('start')
          .to(
            this,
            2,
            {
              progress: 0,
              ease: Power2.easeInOut
            },
            `start+=0`
          )
      },
      updateProgress(){
        this.progress = this.progress + (this.sceneProgress - this.progress) * 0.1
        //console.log(666, (this.progress+0.199)%0.2/0.1994)
        this.offsetX = this.camera.components['gyro-position'].offset.x
        this.offsetY = this.camera.components['gyro-position'].offset.y

      },
      playVid(id){
        if (this.vid)
          this.vid.pause()
        this.vid = document.getElementById('anime'+id)
        this.vid.play()
      },
      playSound(id){
        if (this.sound) this.sound.pause()
        this.sound = SoundService.get(id)
        this.sound.on('end', () => {
          this.end()
        })
        if (this.sound) this.sound.play()
      },
      stopSound(){
        if (this.sound) this.sound.pause()
      },
      playSoundFromStart(id){
        if (this.sound) this.sound.pause()
        this.sound = SoundService.get(id)
        this.sound.currentTime = 0
        this.sound.on('end', () => {
          this.end()
        })
        if (this.muted){
          this.sound.muted = true
        } else {
          this.sound.muted = false
        }
        if (this.sound) this.sound.play()
      },
      easeOutCubic(t) {
        return (--t)*t*t+1
      },
      monsterIn(){
        //this.updateSpineIdx()
        //console.log("!!!!!", this.monsterFade)
        let tl = new TimelineMax({ onComplete: () => {
            //console.log(this.monsterFade)
            this.unlockMode()
            window.AVPlayer.playSoundFromStart(1, this.currSceneIdx)
          }
        })
        this.tl = tl
        tl.add('start')
          .to(
            this,
            1,
            {
              monsterFade: 1,
              ease: Power2.easeOut
            },
            `start+=0`
          )
      },
      updateSpineIdx(){
        this.spineIdx = this.currSceneIdx
      }
    },
    watch: {


      muted(val){

      },
      mode(val){
        if (val === 0)
          this.monsterFade = 0


      },

      sceneEntered(val){


      },

      currSceneIdx(val){
        //prevent fast swipe causing monster show up wrong

        if (this.sceneEntered){
          if (this.tl) {
            this.tl.seek(this.tl.endTime())
            this.tl.kill()
            this.tl = null
          }
          this.monsterFade = 0

        } else {

        }



      },
      sceneProgress(value){
        //console.log(value%0.2/0.2)
        let val = value*4.0


      }
    },
  }
</script>

<style lang="sass" scoped>
  @import "src/styles/common.sass"

  //.intro
    position: absolute
  .gyroview
    +full()
    //background: greenyellow
    .subcontainer
      //background: greenyellow

      position: absolute
      width: 100%
      height: 1rem
      bottom: 1rem
      .subtitles
        //background: #ffd81b
        color: white
        font-size: $fs-l




</style>
